<div class="space-y-6 animate-fade-in-up font-sans">

  <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 relative overflow-hidden">
    <div class="absolute left-0 top-0 bottom-0 w-1 bg-[#1e3a8a]"></div>

    <div class="flex items-center gap-4">
      <div class="bg-blue-50 p-3 rounded-xl text-[#1e3a8a] shadow-inner">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path></svg>
      </div>
      <div>
        <h2 class="text-2xl font-black text-[#1e3a8a] tracking-wide uppercase">Gestión de Tickets</h2>
        <p class="text-xs text-gray-500 font-medium mt-1">Centro de soporte y mantenimiento</p>
      </div>
    </div>

    <button class="w-full md:w-auto flex items-center justify-center gap-2 bg-[#1e3a8a] hover:bg-[#ffb31c] text-white hover:text-[#1e3a8a] px-5 py-2.5 rounded-xl shadow-md transition-all text-sm font-bold group">
      <svg class="w-4 h-4 transform group-hover:rotate-90 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg>
      Nuevo Ticket
    </button>
  </div>

  <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">

    <div class="flex overflow-x-auto border-b border-gray-100 bg-gray-50/50 custom-scrollbar">
      <button class="flex-1 py-4 px-6 text-sm font-bold text-gray-500 hover:text-[#1e3a8a] border-b-2 border-transparent hover:border-gray-300 transition-colors whitespace-nowrap">
        Emergencias
        <span class="ml-2 bg-red-100 text-red-600 py-0.5 px-2 rounded-full text-[10px]">3</span>
      </button>
      <button class="flex-1 py-4 px-6 text-sm font-black text-[#1e3a8a] border-b-2 border-[#1e3a8a] bg-white shadow-[0_-4px_0_0_#1e3a8a_inset] transition-colors whitespace-nowrap">
        Preventivos
        <span class="ml-2 bg-blue-100 text-[#1e3a8a] py-0.5 px-2 rounded-full text-[10px]">12</span>
      </button>
      <button class="flex-1 py-4 px-6 text-sm font-bold text-gray-500 hover:text-[#1e3a8a] border-b-2 border-transparent hover:border-gray-300 transition-colors whitespace-nowrap">
        Correctivos
        <span class="ml-2 bg-gray-200 text-gray-600 py-0.5 px-2 rounded-full text-[10px]">5</span>
      </button>
    </div>

    <div class="p-4 bg-white border-b border-gray-100 flex flex-col sm:flex-row gap-4">
      <div class="relative flex-1 group">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-4 w-4 text-gray-400 group-focus-within:text-[#ffb31c] transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
        </div>
        <input type="text" placeholder="Buscar por código, sitio o actividad..." class="block w-full pl-10 pr-3 py-2.5 border border-gray-200 rounded-xl leading-5 bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#ffb31c] focus:bg-white transition-all text-sm font-medium shadow-sm">
      </div>

      <div class="relative w-full sm:w-48">
        <select class="block w-full pl-3 pr-10 py-2.5 border border-gray-200 rounded-xl leading-5 bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#ffb31c] focus:bg-white transition-all text-sm font-bold shadow-sm appearance-none cursor-pointer">
          <option>Todos los Estados</option>
          <option>Abierto</option>
          <option>En Proceso</option>
          <option>Cerrado</option>
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-500">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg>
        </div>
      </div>
    </div>

    <div class="divide-y divide-gray-100 bg-white">

      <div class="hidden md:grid grid-cols-12 gap-4 px-6 py-3 bg-gray-50/50 text-xs font-bold text-gray-500 uppercase tracking-wider">
        <div class="col-span-3 lg:col-span-2">Ticket / Sitio</div>
        <div class="col-span-4 lg:col-span-4">Actividad</div>
        <div class="col-span-2 lg:col-span-2 text-center">Estado / Prioridad</div>
        <div class="col-span-2 lg:col-span-2">Responsable</div>
        <div class="col-span-1 lg:col-span-2 text-right">Acción</div>
      </div>

      @for (t of tickets; track t.codigoSitio) {
        <div class="group flex flex-col md:grid md:grid-cols-12 gap-4 px-6 py-4 items-center hover:bg-blue-50/50 transition-colors cursor-pointer border-l-4 border-transparent hover:border-l-[#1e3a8a]">

          <div class="w-full md:w-auto col-span-3 lg:col-span-2 flex flex-col">
            <span class="font-black text-[#1e3a8a] text-sm">{{ t.codigoSitio }}</span>
            <span class="text-xs font-medium text-gray-400 mt-0.5 flex items-center gap-1">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
              {{ t.fechaAsignacion }}
            </span>
          </div>

          <div class="w-full md:w-auto col-span-4 lg:col-span-4">
            <p class="font-bold text-gray-800 text-sm line-clamp-2 group-hover:text-[#1e3a8a] transition-colors">{{ t.actividad }}</p>
          </div>

          <div class="w-full md:w-auto col-span-2 lg:col-span-2 flex flex-row md:flex-col items-center justify-start md:justify-center gap-2 md:gap-1">

            <span class="px-2.5 py-1 rounded-md text-[10px] font-black uppercase tracking-wider shadow-sm border w-full text-center"
                  [class.bg-blue-50]="t.estado === 'En Proceso'" [class.text-[#1e3a8a]]="t.estado === 'En Proceso'" [class.border-blue-200]="t.estado === 'En Proceso'"
                  [class.bg-yellow-50]="t.estado === 'Abierto'" [class.text-yellow-700]="t.estado === 'Abierto'" [class.border-yellow-200]="t.estado === 'Abierto'"
                  [class.bg-gray-100]="t.estado === 'Cerrado'" [class.text-gray-500]="t.estado === 'Cerrado'" [class.border-gray-200]="t.estado === 'Cerrado'">
              {{ t.estado }}
            </span>

            <div class="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider"
                 [class.text-red-600]="t.prioridad === 'Alta'"
                 [class.text-[#ffb31c]]="t.prioridad === 'Media'"
                 [class.text-green-600]="t.prioridad === 'Baja'">
                 <span class="w-1.5 h-1.5 rounded-full"
                       [class.bg-red-600]="t.prioridad === 'Alta'"
                       [class.bg-[#ffb31c]]="t.prioridad === 'Media'"
                       [class.bg-green-600]="t.prioridad === 'Baja'"></span>
              {{ t.prioridad }}
            </div>
          </div>

          <div class="w-full md:w-auto col-span-2 lg:col-span-2 flex items-center gap-2">
            <div class="w-8 h-8 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center text-xs font-black border border-gray-200 shadow-sm" title="{{ t.responsable }}">
              {{ t.responsable.charAt(0) }}
            </div>
            <span class="text-sm font-medium text-gray-600 truncate">{{ t.responsable }}</span>
          </div>

          <div class="w-full md:w-auto col-span-1 lg:col-span-2 flex justify-end md:justify-end mt-2 md:mt-0">
            <button class="bg-white border border-gray-200 text-[#1e3a8a] px-4 py-1.5 rounded-lg text-xs font-bold hover:bg-[#1e3a8a] hover:text-white shadow-sm transition-colors opacity-100 md:opacity-0 group-hover:opacity-100">
              Ver Detalle
            </button>
          </div>

        </div>
      }
    </div>
  </div>
</div>
